module.exports = __webpack_public_path__ + "assets/8fbed8797e6f7ea43fda1e3edde4a2a3.png";